import axios from 'axios'
import { SAVINGS_PLAN_SUBSCRIPTION_ENDPOINT } from 'common/backend/endpoints'

async function generatePDF(id) {
    const endpoint = SAVINGS_PLAN_SUBSCRIPTION_ENDPOINT + '/generar-pdf-plan-de-ahorro/' + id;

    const response = await axios.get(endpoint);
    return response.data;
}

export default generatePDF;
